module.exports = __webpack_public_path__ + "static/media/Sigurd.33c62618.jpg";